export class KeyValuePairModel {
    constructor(
        public key: string,
        public value: string
    ) {
    }
}


